export const MATTER_LITIGATION_DATE_TYPE_CATEGORY_OPTIONS = [
  "Filing & Service",
  "Discovery",
  "Motions & Hearings",
  "ADR / Settlement",
  "Trial Prep",
  "Trial & Verdict",
] as const;

export const CATEGORY_TO_DUMMY_DATA_MAP = {
  "Filing & Service": [
    {
      dataType: "Attorney Assigned",
      dataValue: "John Smith",
    },
    {
      dataType: "Jurisdiction / County",
      dataValue: "Los Angeles County",
    },
    {
      dataType: "Court Division",
      dataValue: "Law Division ($50K+)",
    },
    {
      dataType: "Complaint Filed Date",
      dataValue: "Oct 15, 2025",
    },
    {
      dataType: "Case Number",
      dataValue: "25-CV-12345",
    },
    {
      dataType: "Service Status per Defendant",
      dataValue: "ABC Transport Inc. - In Progress",
    },
    {
      dataType: "Served / Not Served",
      dataValue: "Not Served",
    },
    {
      dataType: "Process Server",
      dataValue: "ABC Process Services",
    },
  ],

  Discovery: [
    {
      dataType: "Discovery Propounded Date",
      dataValue: "Oct 15, 2025",
    },
    {
      dataType: "Defendant Discovery Responses Due",
      dataValue: "Nov 15, 2025",
    },
    {
      dataType: "Plaintiff's Discovery Responses Due",
      dataValue: "Nov 20, 2025",
    },
    {
      dataType: "HIPAA Order Filed Date",
      dataValue: "Nov 10, 2025",
    },
    {
      dataType: "Discovery Completed Status",
      dataValue: "In Progress",
    },
    {
      dataType: "Depositions Scheduled / Completed",
      dataValue: "2 Scheduled, 0 Completed",
    },
    {
      dataType: "Plaintiff Depo",
      dataValue: "Nov 25, 2025",
    },
    {
      dataType: "Defendant Depo",
      dataValue: "Nov 25, 2025",
    },
  ],

  "Motions & Hearings": [
    {
      dataType: "Hearing Date(s)",
      dataValue: "Feb 15, 2026",
    },
    {
      dataType: "Motion Type",
      dataValue: "Motion for Summary Judgment",
    },
    {
      dataType: "Filed Date",
      dataValue: "Jan 15, 2026",
    },
    {
      dataType: "Opposition Due Date",
      dataValue: "May 1, 2026",
    },
    {
      dataType: "Reply Due Date",
      dataValue: "Mar 8, 2026",
    },
    {
      dataType: "Ruling / Outcome",
      dataValue: "Pending",
    },
    {
      dataType: "Judge / Department",
      dataValue: "Hon. Sarah Williams, Dept. 12",
    },
    {
      dataType: "Case Management Conference (CMC)",
      dataValue: "Jan 15, 2026",
    },
  ],

  "ADR / Settlement": [
    {
      dataType: "Mediation Date",
      dataValue: "Apr 12, 2026",
    },
    {
      dataType: "Mediator",
      dataValue: "Charles Bennett, Esq.",
    },
    {
      dataType: "ADR Provider / Location",
      dataValue: "ADR Services, Inc. — DTLA",
    },
    {
      dataType: "Plaintiff Demand",
      dataValue: "$325,000",
    },
    {
      dataType: "Defendant Offer",
      dataValue: "$95,000",
    },
    {
      dataType: "Mediation Outcome",
      dataValue: "Impasse",
    },
    {
      dataType: "Settlement Conference (MSC) Date",
      dataValue: "May 20, 2026",
    },
    {
      dataType: "Settlement Agreement Executed",
      dataValue: "N/A",
    },
  ],

  "Trial Prep": [
    {
      dataType: "Final Status Conference",
      dataValue: "Jun 15, 2026",
    },
    {
      dataType: "Witness List Due",
      dataValue: "Jun 5, 2026",
    },
    {
      dataType: "Exhibit List Due",
      dataValue: "Jun 5, 2026",
    },
    {
      dataType: "Motions in Limine Filing Deadline",
      dataValue: "Jun 8, 2026",
    },
    {
      dataType: "Trial Brief Due",
      dataValue: "Jun 10, 2026",
    },
    {
      dataType: "Proposed Jury Instructions",
      dataValue: "Submitted Jun 12, 2026",
    },
    {
      dataType: "Subpoenas Served",
      dataValue: "4 of 6 Served",
    },
    {
      dataType: "Trial Binders",
      dataValue: "Drafting In Progress",
    },
  ],

  "Trial & Verdict": [
    {
      dataType: "Trial Start",
      dataValue: "Jun 22, 2026",
    },
    {
      dataType: "Trial Type",
      dataValue: "Jury Trial",
    },
    {
      dataType: "Judge / Department",
      dataValue: "Hon. Sarah Williams, Dept. 12",
    },
    {
      dataType: "Verdict Date",
      dataValue: "Jul 1, 2026",
    },
    {
      dataType: "Verdict",
      dataValue: "For Plaintiff",
    },
    {
      dataType: "Damages Awarded",
      dataValue: "$410,000",
    },
    {
      dataType: "Judgment Entered",
      dataValue: "Jul 8, 2026",
    },
    {
      dataType: "Post-Trial Motions / Appeal Deadline",
      dataValue: "Aug 5, 2026",
    },
  ],
} satisfies Record<
  (typeof MATTER_LITIGATION_DATE_TYPE_CATEGORY_OPTIONS)[number],
  { dataType: string; dataValue: string }[]
>;

/** `matterUserConnectionLabel` for rows linked to a matter litigation date. */
export const MATTER_LITIGATION_DATE_USER_CONNECTION_LABEL =
  "Litigation Date User";

/** Form, card, and table copy: team member accountable for this date being completed. */
export const MATTER_LITIGATION_DATE_RESPONSIBLE_FIELD_LABEL = "Responsible";
